import { buildRouteProfile } from "./profile.js";

export class ElevationService {
  buildProfile(waypoints, segments) {
    return buildRouteProfile(combineSegmentCoordinates(waypoints, segments));
  }

  getOrderedCoordinates(waypoints, segments) {
    return combineSegmentCoordinates(waypoints, segments);
  }
}

function combineSegmentCoordinates(waypoints, segments) {
  const points = [];

  for (let index = 0; index < waypoints.length - 1; index += 1) {
    const fromId = waypoints[index].id;
    const toId = waypoints[index + 1].id;
    const segment = segments.find((item) => item.fromId === fromId && item.toId === toId);
    if (!segment || !Array.isArray(segment.coordinates)) {
      continue;
    }

    segment.coordinates.forEach((point) => {
      const previous = points[points.length - 1];
      if (previous && previous.latitude === point.latitude && previous.longitude === point.longitude) {
        return;
      }
      points.push(Object.assign({}, point));
    });
  }

  return points;
}
